import {
  Breakpoints,
  BreakpointWrapper,
  ButtonNext,
  ButtonPrevious,
  styled,
  Text,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { ArrowLeft, Close } from '@volkswagen-onehub/icons-core';
import { InteractionLayerSizeV2, LayerHandleV2, LayerManagerV2 } from '@volkswagen-onehub/layer-manager';
import React, { useEffect, useRef, useState } from 'react';
import { Provider, useStore } from 'react-redux';
import { CarlineOffer } from 'src/components';
import {
  CarlineContext,
  FeatureAppEnvironmentContext,
  useFeatureAppEnvironment,
  useFeatureServices,
} from 'src/feature-app/hooks';
import { CarlineWithOffers, Offer } from 'src/types';
import {
  getVisibleTrimSelectionColumnCount,
  MobileHeader,
  TrimSelectionColumn,
  useSlider,
  useViewportWidth,
} from '../MofaCarousel';
import { MofaCarousel } from '../MofaCarousel/MofaCarousel';
import { useElementWidth } from '../MofaCarousel/use-element-width';
import { CarlineOfferCampaign } from 'src/components/CarlineOfferCampaign';

const CloseDiv = styled.div`
  position: fixed;
  color: #001e50;
  cursor: pointer;
  padding-top: 12px;
  padding-left: 20px;
  padding-bottom: 12px;
  top: 0;
  z-index: 1;
  background-color: #ffffff;
  width: 100%;
  &.close-enter {
    opacity: 0;
  }
  &.close-enter-active {
    opacity: 1;
    transition: opacity ${600} ease-in;
  }
  &.close-enter-done {
  }
  &.close-exit {
    transform: translate(0, 0);
    opacity: 1;
  }
  &.close-exit-active {
    transform: translate(0, -100%);
    opacity: 0.01;
    transition: all ${400}, opacity ${600} ease-in;
  }
`;

interface MobileOfferProps {
  carline: CarlineWithOffers;
  showOffer: boolean;
  setShowOfferToFalse: () => void;
  unSelectCarline: () => void;
  showCard: boolean;
}

function InnerOffer(props: MobileOfferProps) {
  const { carline, setShowOfferToFalse, unSelectCarline, showCard } = props;
  const [showLead, setShowLead] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(
    carline.ofertas.length === 1 ? carline.ofertas[0] : null
  );
  const numberOfOffers = carline.ofertasCampaign
    ? carline.ofertas.length + carline.ofertasCampaign.length
    : carline.ofertas.length;

  const [sliderWidth, sliderElementRef] = useElementWidth();
  const viewportWidth = useViewportWidth();
  const offsetHasBeenChanged = React.useRef(false);
  const [activeTrimIndex, setActiveTrimIndex] = useState(0);

  const visibleSlideCount = getVisibleTrimSelectionColumnCount(viewportWidth);

  const slider = useSlider({
    sliderWidth,
    offset: activeTrimIndex,
    totalSlideCount: carline.ofertasCampaign
      ? carline.ofertas.length + carline.ofertasCampaign.length
      : carline.ofertas.length,
    visibleSlideCount,

    onOffsetChange: React.useCallback(
      (newOffset, direction) => {
        offsetHasBeenChanged.current = true;
        setActiveTrimIndex(newOffset);
      },
      [setActiveTrimIndex]
    ),
  });

  return (
    <div style={{ backgroundColor: '#FFFFFF' }}>
      {showLead ? (
        <CloseDiv
          onClick={(e) => {
            e.preventDefault();
            setShowLead(false);
          }}
        >
          <ArrowLeft />
        </CloseDiv>
      ) : showCard ? (
        <CloseDiv
          onClick={() => {
            setShowOfferToFalse();
            unSelectCarline();
          }}
        >
          <Close />
        </CloseDiv>
      ) : null}
      <div style={{ marginTop: '56px' }}>
        <h1 style={{ textAlign: 'center' }}>
          Ofertas {carline.nuevo ? 'Nuevo' : null} {carline.title}
        </h1>
        <CarlineContext.Provider value={carline}>
          {!showLead ? (
            carline.ofertas.length === 1 && !carline.ofertasCampaign ? (
              <CarlineOffer
                offer={selectedOffer}
                activeComparador={true}
                numberOfOffers={1}
                showCard={showCard}
                offerNumber={1}
                key={`${selectedOffer.anchor}-m`}
                setShowOfferToFalse={setShowOfferToFalse}
                unSelectCarline={unSelectCarline}
                setShowLead={setShowLead}
              />
            ) : (
              <>
                <MobileHeader
                  previousButton={
                    slider.previous && (
                      <ButtonPrevious tag="button" emphasis="tertiary" onClick={slider.previous}>
                        anterior
                      </ButtonPrevious>
                    )
                  }
                  counter={<Text bold>{`${slider.pageIndex + 1} / ${slider.pageCount}`}</Text>}
                  nextButton={
                    slider.next && (
                      <ButtonNext tag="button" emphasis="tertiary" onClick={slider.next}>
                        siguiente
                      </ButtonNext>
                    )
                  }
                />
                <MofaCarousel
                  sliderElementRef={sliderElementRef}
                  onPrevious={slider.previous}
                  onNext={slider.next}
                  paginationHasBeenUsed={offsetHasBeenChanged.current}
                >
                  {carline.ofertasCampaign && (
                    <TrimSelectionColumn
                      key={0}
                      index={0}
                      bindGestureHandlers={slider.bindGestureHandlers}
                      spring={slider.springs[0]}
                      onFocusInvisible={() => setActiveTrimIndex(-1)}
                    >
                      <CarlineOfferCampaign
                        offer={carline.ofertas[0]}
                        activeComparador={false}
                        numberOfOffers={numberOfOffers}
                        showCard={false}
                        setSelectedOffer={setSelectedOffer}
                        offerNumber={0}
                        setShowOfferToFalse={setShowOfferToFalse}
                        unSelectCarline={unSelectCarline}
                      />
                    </TrimSelectionColumn>
                  )}
                  {carline.ofertas.map((offer, index) => {
                    <></>;
                    return (
                      <TrimSelectionColumn
                        key={carline.ofertasCampaign ? index + 2 : index}
                        index={carline.ofertasCampaign ? index + 1 : index}
                        bindGestureHandlers={slider.bindGestureHandlers}
                        spring={slider.springs[carline.ofertasCampaign ? index + 1 : index]}
                        onFocusInvisible={() => setActiveTrimIndex(index)}
                      >
                        <CarlineOffer
                          offer={offer}
                          activeComparador={true}
                          numberOfOffers={numberOfOffers}
                          showCard={showCard}
                          setSelectedOffer={setSelectedOffer}
                          offerNumber={index + 1}
                          key={`${offer.anchor}-${index}-c`}
                          setShowOfferToFalse={setShowOfferToFalse}
                          unSelectCarline={unSelectCarline}
                          setShowLead={setShowLead}
                        />
                      </TrimSelectionColumn>
                    );
                  })}
                </MofaCarousel>
              </>
            )
          ) : null}
        </CarlineContext.Provider>
      </div>
    </div>
  );
}

export const OfferView375 = (props: MobileOfferProps) => {
  const { showCard } = props;
  const store = useStore();
  const env = useFeatureAppEnvironment();
  const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
  const layerRef = useRef<LayerHandleV2<any>>(null);

  useEffect(() => {
    return () => {
      if (layerRef.current) {
        layerRef.current.close();
      }
    };
  }, []);

  const renderOffer = () => {
    return (
      <BreakpointWrapper max={Breakpoints.b560}>
        <Provider store={store}>
          <FeatureAppEnvironmentContext.Provider value={env}>
            <ThemeProvider>
              <InnerOffer {...props} />;
            </ThemeProvider>
          </FeatureAppEnvironmentContext.Provider>
        </Provider>
      </BreakpointWrapper>
    );
  };

  const renderInteractionLayer = (): any => {
    if (!layerRef.current && showCard && window.innerWidth < 560) {
      const layer = layerManager.openInteractionLayer(renderOffer, {}, { size: InteractionLayerSizeV2.D });
      layerRef.current = layer;
    }
    return null;
  };

  return (
    <div>
      {showCard ? (
        <BreakpointWrapper max={Breakpoints.b560}>{renderInteractionLayer()}</BreakpointWrapper>
      ) : (
        <InnerOffer {...props} />
      )}
    </div>
  );
};
